











import auth from '../auth'
import Pusher from 'pusher-js'
import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import store from 'store'
import Loader from '@/components/common/Loader.vue'
import HomeScreenWarningModal from '@/components/modals/HomeScreenWarningModal.vue'
import {Navigator} from '@/store/types'

@Component({
  components: {
    Loader,
    HomeScreenWarningModal,
  },
})

export default class Master extends Vue {
  public showAppHomeScreenModal = false
  public loaded = false

  @Getter('appVersion') public appVersion!: any
  @Action('getAppVersion') public getAppVersion: any
  @Mutation('setSignatures') public setSignatures: any
  @Mutation('setCanceledTask') public setCanceledTask!: any
  @Action('getTaskList') public getTaskList: any
  @Action('getRoomTypes') public getRoomTypes: any
  @Action('getItemTypes') public getItemTypes: any
  @Action('getServiceTypes') public getServiceTypes: any
  @Action('getUsers') public getUsers: any
  @Action('groupLoading') public groupLoading: any
  @Action('getNotificationList') public getNotificationList!: any
  @Action('getGroups') public getGroups: any

  public auth = auth

  public pusherInit() {
    if (process.env.PUSHER_KEY !== undefined) {
      const pusher = new Pusher( process.env.PUSHER_KEY , {
        cluster: process.env.PUSHER_CLUSTER,
      })

      const channel = pusher.subscribe(`user_${auth.user.profile.id}`)

      channel.bind('survey-canceled', (data) => {
        this.setCanceledTask(data.survey_id)
      })
    }
  }

  public keydown(e: KeyboardEvent) {
    const key = e.key || e.keyCode || e.which || e.charCode
    if (key === 'Enter') {
      setTimeout(() => {
        (document.activeElement as HTMLElement).blur()
      }, 200)
    }
  }

  public mounted() {

    this.getAppVersion().then(() => {
      const envVersion: any = process.env.APP_VERSION

      if (this.appVersion !== parseInt(envVersion, 10)) {
          window.location.reload()
          return
      }

      this.groupLoading([
        this.getRoomTypes(),
        this.getItemTypes(),
        this.getServiceTypes(),
        this.getNotificationList(),
        this.getUsers(),
        this.getGroups(),
        this.pusherInit(),
      ]).then((value: any[]) => {
        this.loaded = true
      })
    })

    let navigator: any
    navigator = window.navigator

    if ( navigator.standalone === false) {
      this.showAppHomeScreenModal = true
    }

    window.addEventListener('keydown', this.keydown)

    if (store.get('signatures') !== undefined) {
      this.setSignatures(store.get('signatures'))
    }
  }
}
